import React from 'react';
import Slider from '@mui/material/Slider';
import { Typography } from '@mui/material';

export type P_SliderForEdit = P_SliderForEditBase & {
	id: string;
	max: number;
	min: number;
	step: number;
};
export type P_SliderForEditBase = {
	onChange: (value: number) => any;
	value: number;
	marks: t_sliderMarks[];
};
type t_sliderMarks = {
	value: number;
	label: string;
};

export default function SliderForEdit(props: P_SliderForEdit) {
	const onChange = React.useCallback(
		(_: any, value: number | number[]) =>
			props.onChange(Array.isArray(value) ? value[0] : value),
		[],
	);

	const labelId = props.id + '-label';
	return (
		<Slider
			style={{ marginTop: 0 }}
			aria-label={labelId}
			value={props.value}
			min={props.min}
			max={props.max}
			step={props.step}
			valueLabelDisplay='off'
			onChange={onChange}
			marks={props.marks}
			size={'small'}
			components={{ MarkLabel: MarkLabel }}
		/>
	);
}

const MarkLabel = (props: { children: React.ReactElement }) => (
	<Typography variant='overline' color={'textSecondary'} mt={1}>
		{props.children}
	</Typography>
);
